import {
  SourceBaseView,
  useGetAllSources,
  useGetSourcesOfInterest,
} from "../api-generated";
import { formatDateTime } from "../utils";
import Table from "./Table";
import SourceTypeIcon from "./SourceTypeIcon";
import ErrorLoading from "./ErrorLoading";
import { getPlatzSourceLink } from "../utils/navigation";
import Header from "./Header";
import { useState } from "react";
import Button from "./Button";

const COLUMNS = [
  {
    columnName: "Id",
    getContent: (row: SourceBaseView) => <div>{row.id}</div>,
    isId: true,
  },
  {
    columnName: "Type",
    getContent: (row: SourceBaseView) => <SourceTypeIcon type={row.type} />,
    isIcon: true,
  },
  {
    columnName: "Name",
    getContent: (row: SourceBaseView) => <div>{row.name}</div>,
    isTitle: true,
  },
  {
    columnName: "Created At",
    getContent: (row: SourceBaseView) => (
      <div>{formatDateTime(row.createdAt)}</div>
    ),
    isCreatedAt: true,
  },
];

const AllSources = () => {
  const { data: sources, error, isLoading } = useGetAllSources();

  if (error) {
    return <ErrorLoading error={error} />;
  }

  return (
    <div className="flex flex-col gap-4">
      <Header type="main" text="All Sources" />
      <Table
        columns={COLUMNS}
        rows={sources || []}
        navigateOnClick={getPlatzSourceLink}
        isLoading={isLoading}
      />
    </div>
  );
};

const SourceList = () => {
  const {
    data: sourceOfInterest,
    error,
    isLoading,
  } = useGetSourcesOfInterest();

  const [showAllSources, setShowAllSources] = useState<boolean>(false);

  if (error) {
    return <ErrorLoading error={error} />;
  }

  return (
    <div>
      <div className="flex flex-col gap-4">
        <Header type="main" text="Sources of Interest" />
        <Table
          columns={COLUMNS}
          rows={sourceOfInterest || []}
          navigateOnClick={getPlatzSourceLink}
          isLoading={isLoading}
        />
      </div>
      <div className="py-8">
        {showAllSources ? (
          <AllSources />
        ) : (
          <Button
            label="Show all Sources"
            onClick={() => setShowAllSources(true)}
            type="primary"
          />
        )}
      </div>
    </div>
  );
};

export default SourceList;
